/**
 * Whether a card was AI-generated (Art. 50 Abs. 2 AI Act — machine-readable
 * marking of generated content, in force from 2026-12-02). Shared by
 * DeckManager.jsx (the card list) and CardRenderer.jsx (the card a learner
 * actually studies, rendered by ReviewSession.jsx).
 *
 * The `cards` table has no `generated`/`source` column. The signal that does
 * exist is `metadata`: the card-generation route always supplies it — even
 * `{}` for a card that is not multiple_choice — while the manual "New card"
 * form (`POST /api/learning/cards`) never sends one, so the column stays
 * NULL for a hand-typed card (see src/learning/card-generator.js and
 * src/server/routes/learning.js: `INSERT INTO cards (...)` with vs. without
 * `metadata`). A card is therefore AI-generated when it carries a metadata
 * object — EXCEPT `metadata.import_mode === 'extracted'`: the catalog
 * importer (src/catalog/processor.js) sets that for a question transcribed
 * verbatim from an uploaded page image. Its content is the source document's
 * own text, not something an AI invented, so it must not carry the same
 * "AI-generated" marker as a card card-generator.js actually produced.
 */
export function isAiGeneratedCard(card) {
  if (card == null || card.metadata == null) return false;
  return card.metadata.import_mode !== 'extracted';
}
